// @README this defines how deep our categories can go. Currently set to 3, meaning a category can have 2 parents at most
export const MaxCategoryDepth = 3;